import moment from "moment";
import { useEffect, useState } from "react";
import useNearScreen from "../../../../../hooks/useNearScreen";
import SvgIcon from "../../../../../parts/SvgIcon";
import BodyPhotos from "./BodyPhotos";
import StatInformation from "./StatInformation";

const ListViewItem = ({ stat, choosing, selectPhotos, selectedPhotos }) => {
  const { isNearScreen, elementRef } = useNearScreen();
  const [selected, setSelected] = useState(false);
  const handleClick = () => {
    selectPhotos(stat);
  };
  useEffect(() => {
    if (selectedPhotos?.includes(stat)) setSelected(true);
    else setSelected(false);
  }, [selectedPhotos, stat]);
  return (
    <article ref={elementRef}>
      {isNearScreen && (
        <>
          <header>
            {choosing ? (
              <hgroup>
                {/* <SvgIcon
                  alt="checked"
                  src={
                    selected
                      ? "/img/new-icons/vuesax-linear-tick-circle-gradient.svg"
                      : "/img/new-icons/vuesax-linear-tick-circle.svg"
                  }
                /> */}
                <div className="date">
                  {moment(stat.utcDate, "YYYYMMDD").format("MMM D, YYYY")}
                </div>
              </hgroup>
            ) : (
              <hgroup className="date">
                {moment(stat.utcDate, "YYYYMMDD").format("MMM D, YYYY")}
              </hgroup>
            )}
            <StatInformation stat={stat} />
          </header>
          <BodyPhotos
            photos={stat.bodyPhotos}
            dailyStatId={stat._id}
            utcDate={stat.utcDate}
          />
          {(selected || (choosing && selectedPhotos.length < 2)) && (
            <div
              className={`progress-item-overlay ${selected ? "selected" : ""}`}
              onClick={handleClick}
            >
              <SvgIcon
                src={
                  !selected
                    ? "/img/new-icons/tick-circle-outline-white.svg"
                    : "/img/new-icons/close-circle-outline-white.svg"
                }
                noFilterOnLight={true}
              />
              <h2>{selected ? "Deselect" : "Select"}</h2>
            </div>
          )}
        </>
      )}
    </article>
  );
};

export default ListViewItem;
